var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRecent16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 2.5a5.5 5.5 0 100 11 5.5 5.5 0 000-11zM1 8a7 7 0 1114 0A7 7 0 011 8zm6.25-4a.75.75 0 01.75.75v3.517l2.31 1.05a.75.75 0 01-.62 1.366l-2.75-1.25a.75.75 0 01-.44-.683v-4A.75.75 0 017.25 4z",
    clipRule: "evenodd"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDE2IDE2Ij48cGF0aCBmaWxsPSJjdXJyZW50Q29sb3IiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTggMi41QzQuOTYyNCAyLjUgMi41IDQuOTYyNCAyLjUgOHMyLjQ2MjQgNS41IDUuNSA1LjUgNS41LTIuNDYyNCA1LjUtNS41UzExLjAzNzYgMi41IDggMi41Wk0xIDhjMC0zLjg2NiAzLjEzNC03IDctN3M3IDMuMTM0IDcgNy0zLjEzNCA3LTcgNy03LTMuMTM0LTctN1ogTTcuMjUgNGEuNzUuNzUgMCAwIDEgLjc1Ljc1djMuNTE3bDIuMzEwNCAxLjA1MDJhLjc1MDEuNzUwMSAwIDAgMS0uNjIwNyAxLjM2NTZsLTIuNzUtMS4yNUEuNzUuNzUgMCAwIDEgNi41IDguNzV2LTRBLjc1Ljc1IDAgMCAxIDcuMjUgNFoiIGNsaXAtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPgo=";
export { SvgRecent16 as ReactComponent };